import { endpoints, oids } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

interface GetConditionByOrganizationParams {
  /** Organization id sem prefixo, ex: 05490544000100 */
  organizationId: string;
  /** Data inicial YYYY-MM-DD (opcional) */
  startDate?: string;
  /** Data final YYYY-MM-DD (opcional) */
  endDate?: string;
  /** Quantity de registros (default 100) */
  count?: number;
  /** Incluir recursos relacionados via include (opcional) */
  includeEncounter?: boolean;
  /** Indica se deve retornar apenas o resumo (opcional) */
  summary?: boolean;
  /** Incluir Patient no bundle */
  includePatient?: boolean;
}

/**
 * Busca Condition por organização via parâmetro encounter.service-provider
 */
export async function GetConditionByOrganization({
  organizationId,
  startDate,
  endDate,
  summary,
  count = 100,
  includeEncounter,
  includePatient,
}: GetConditionByOrganizationParams) {
  let url = `${endpoints.STATISTICS}/Condition?encounter.service-provider=Organization/${oids.cnpj}-${organizationId}`;
  if (startDate) url = `${url}&_lastUpdated=ge${startDate}`;
  if (endDate) url = `${url}&_lastUpdated=le${endDate}`;
  if (count) url = `${url}&_count=${count}`;
  if (includeEncounter) url = `${url}&_include=Condition:encounter`;
  if (includePatient) url = `${url}&_include=Condition:patient`;
  if (summary) url = `${url}&_summary=count`;

  const subjectId = await useAuth.getSubjectId();
  const orgIdHeader = await useAuth.getOrganizationId();

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
    ...(subjectId && { "subject-id": subjectId }),
    ...(orgIdHeader && { "organization-id": orgIdHeader }),
  } as Record<string, string>;

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Get Condition By Organization: ${response.status}`);
      }
      return response.data as fhir5.Bundle;
    })
    .catch((error) => {
      console.error("GetConditionByOrganization ", error);
      throw new Error();
    });

  return response;
}
